import React from "react";
import { sourceIcon, sourceLabel } from "../../pages/workspace/panels/artifactProvenance";

// Inline chip rendered next to a column header when the column has a
// declared source. Click highlights the corresponding row in the v2
// Sources panel. Passes `src` alongside `storeId` so the host handler can
// resolve on demand when storeId is null (unregistered mid-stream or a
// plexId-only source) instead of the chip being an inert click (PLEX-4228).
export const SourceColChip = ({ src, storeId, onClick }) => (
  <button
    type="button"
    className="sar-src-chip"
    title={src?.title || src?.plexId || sourceLabel(src)}
    onClick={(e) => { e.stopPropagation(); onClick?.(storeId, src); }}
    data-store-source-id={storeId || undefined}
    data-testid={`sar-src-chip-${src?.id || "?"}`}
  >
    <span aria-hidden="true">{sourceIcon(src)}</span>
    <span className="sar-src-chip__label">{sourceLabel(src)}</span>
  </button>
);

export default SourceColChip;
